/**
 * Global search — GET /api/search?q=&limit=
 * See data/prd/GLOBAL_SEARCH_PRD.md.
 */
export type GlobalSearchType = "dog" | "club" | "event" | "course";

export const GLOBAL_SEARCH_TYPES: GlobalSearchType[] = ["dog", "club", "event", "course"];

export interface IGlobalSearchResult {
  type: GlobalSearchType;
  /** Mongo _id for every type. */
  id: string;
  /** event / course only — used to build /e/:handle and /c/:handle. */
  handle?: string;
  /** dog call_name | club_name | event/course title */
  name: string;
  /** dog registered_name; event/course club_name */
  secondary?: string;
  city?: string;
  state?: string;
  country?: string;
  /** ISO date, event / course only */
  start_date?: string;
  /** dog owned by the requesting user */
  is_mine?: boolean;
  /** dog profile image / club logo, when set */
  image_url?: string;
}

export interface IGlobalSearchCounts {
  dog: number;
  club: number;
  event: number;
  course: number;
}

export interface IGlobalSearchResponse {
  /** normalised query echoed back so the client can discard stale responses */
  q: string;
  /** ranked, grouped dog → club → event → course */
  results: IGlobalSearchResult[];
  /** candidates per type before the per-type limit */
  counts: IGlobalSearchCounts;
}
